// extracted by mini-css-extract-plugin
export default {"swiper":"Carousel_swiper__z9BT0","slide":"Carousel_slide__M+sqX","navigation":"Carousel_navigation__WQbiE","wrapper":"Carousel_wrapper__v8xeF"};